module.exports = __webpack_public_path__ + "images/saaremaa/favicon-16x16.png";